import branch from './branch'

export default {
  name: 'Branch',
  path: 'branch',
  meta: {
    label: 'branch',
    auth: 'branch'
  },
  component: {
    name: 'Branch',
    render(c) {
      return c('router-view')
    }
  },
  children: [branch]
}
